export default __webpack_public_path__ + "assets/icons/formCopy.6faf8e98.svg";